var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",class:{ isVoting: _vm.vote },on:{"click":function($event){return _vm.goToTopicDetail()}}},[(_vm.vote)?_c('i',{staticClass:"voting"},[_vm._v("投票中")]):_vm._e(),_vm._v(_vm._s(_vm.topicName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }